
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateTask } from '../../Redux/GetSlice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTaskData } from '../../hooks/useTaskData';

const ReminderMe = ({
    selectedReminderDate,   
    updateSelectedReminderDate,
    updateShowReminderMeDropdown,
    // updateSelectedReminderDate,
    note,
    handleReminderChange,
    setIsReminder,
    handleUpdateTask,
    taskItem,
    clickedBellIcon,
    setShowReminderMeDropdown
}) => {

    const {
        // State values
        selectedMyDayPlanDate: reduxSelectedMyDayPlanDate,
     
        isMyDayChecked: reduxIsMyDayChecked,
    
        
        // Action functions
        updateSelectedMyDayPlanDate: updateSelectedMyDayPlanDateRedux,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked: updateIsMyDayCheckedRedux
        
        
    
    } = useTaskData();
    const [customDate, setCustomDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [myDayChecked, setMyDayChecked] = useState(true);
    const [deadlineChecked, setDeadlineChecked] = useState(true);
    
    const today = { daysToAdd: 0, time: { hours: 12, minutes: 0 } };
    const tomorrow = { daysToAdd: 1, time: { hours: 8, minutes: 0 } };
    const inTwoDays = { daysToAdd: 2, time: { hours: 8, minutes: 0 } };
    const nextWeek = { daysToAdd: 7, time: { hours: 8, minutes: 0 } };


   const formatToLocalISO = (date) => {
        const time =date.getTime()
        return formatEpochToISO(time);
    };
    const formatEpochToISO = (epochMillis) => {
        const date = new Date(epochMillis < 1e12 ? epochMillis * 1000 : epochMillis);
        return date.toISOString();
      };

    const formatDateForDisplay = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('en-US', {
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };

    const getFormattedDate = (dateOption) => {
        if (dateOption && typeof dateOption === 'object' && 'daysToAdd' in dateOption) {
            const date = new Date();
            date.setDate(date.getDate() + dateOption.daysToAdd);
            date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
            return date;
        }

        return dateOption;
    };
    
    const handleReminderSelection = (dateOption) => {
        const date = getFormattedDate(dateOption);

      
        const formattedDate = formatToLocalISO(date);

        updateSelectedReminderDate(formattedDate);
        handleUpdateTask(formattedDate, 'reminder', taskItem);
        if (myDayChecked) {
            handleUpdateTask(formattedDate, 'myDay', taskItem);
            updateMyDayDate(formattedDate);
        }
        if (deadlineChecked) {
            updateDeadlineDate(formattedDate);
            handleUpdateTask(formattedDate, 'deadline', taskItem);
        }
        setShowReminderMeDropdown(false)
        // updateShowReminderMeDropdown(false);
        setIsReminder(true);
      
    };

      useEffect(() => {
            if (selectedReminderDate) {
                const date = new Date(selectedReminderDate);
                setCustomDate(date);
            }
        }, [selectedReminderDate]);

    const handleDateChange = (date) => {
        setCustomDate(date);
        setShowDatePicker(false);
        handleReminderSelection(date);
        updateShowReminderMeDropdown(false)
    };

    const handleClearReminder = () => {
        updateSelectedReminderDate(null);
        // dispatch(
        //     updateTask({
        //         newDate: null,
        //         type: 'reminder',
        //         taskItem: taskItem?.id,
        //     }),
        // );
        // setIsReminder(false);
        setShowReminderMeDropdown(false)
        updateShowReminderMeDropdown(false);
    };


    return (
        
        <div className={`${clickedBellIcon ? 'fixed z-30' : 'fixed z-30'}`}
        style={clickedBellIcon ? { top: '50px',right:"2vw", minWidth: 320 } : { minWidth: 320 }}>
            <div className="bg-white rounded-lg shadow-lg border border-gray-100 p-0" style={{ width: 320 }}>
                {/* Header */}
                <div className="flex items-center justify-between px-2 pt-2 pb-1 border-b border-gray-100">
                    <span className="font-semibold text-[15px] text-gray-900">Reminder...</span>
                    <button
                        onClick={handleClearReminder}
                        className="text-[#2196f3] text-xs font-medium hover:underline p-0 m-0 bg-transparent border-none outline-none"
                    >
                        Clear
                    </button>
                </div>

                {/* Textarea */}
                <div className="pt-2 pb-1">
                    <textarea
                        placeholder="Add an optional note or next step"
                        className="w-full border border-gray-200 rounded-md p-2 text-[13px] resize-none focus:ring-1 focus:ring-[#2196f3] focus:border-[#2196f3] outline-none"
                        rows={1}
                        value={note}
                        onChange={handleReminderChange}
                        style={{ minHeight: 24, maxHeight: 60,backgroundColor: 'white' }}
                    ></textarea>
                </div>

                <ul className="text-xs text-gray-800 divide-y divide-gray-100 px-0 mb-0">
                    <li
                        className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                        onClick={() =>{ handleReminderSelection(today)}}
                    >
                        <span className="flex items-center gap-2">
                            <span role="img" aria-label="sun" className="text-[13px] align-middle">
                                ☀️
                            </span>
                            <span className="text-xs">Later today</span>
                        </span>
                        <span className="text-xs text-gray-500 font-medium">
                            {formatDateForDisplay(getFormattedDate(today))}
                        </span>
                    </li>

                    <li
                        className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                        onClick={() => handleReminderSelection(tomorrow)}
                    >
                        <span className="flex items-center gap-2">
                            <span role="img" aria-label="moon" className="text-[13px] align-middle">
                                🌙
                            </span>
                            <span className="text-xs">Tomorrow</span>
                        </span>
                        <span className="text-xs text-gray-500 font-medium">
                            {formatDateForDisplay(getFormattedDate(tomorrow))}
                        </span>
                    </li>

                    <li
                        className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                        onClick={() => handleReminderSelection(inTwoDays)}
                    >
                        <span className="flex items-center gap-2">
                            <span role="img" aria-label="clock" className="text-[13px] align-middle">
                                🕒
                            </span>
                            <span className="text-xs">In two days</span>
                        </span>
                        <span className="text-xs text-gray-500 font-medium">
                            {formatDateForDisplay(getFormattedDate(inTwoDays))}
                        </span>
                    </li>

                    <li
                        className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                        onClick={() => handleReminderSelection(nextWeek)}
                    >
                        <span className="flex items-center gap-2">
                            <span role="img" aria-label="calendar" className="text-[13px] align-middle">
                                📅
                            </span>
                            <span className="text-xs">Next week</span>
                        </span>
                        <span className="text-xs text-gray-500 font-medium">
                            {formatDateForDisplay(getFormattedDate(nextWeek))}
                        </span>
                    </li>

                    <li
                        className="flex items-center px-2 py-2 cursor-pointer hover:bg-gray-50"
                        onClick={() => setShowDatePicker(!showDatePicker)}
                    >
                        <span className="flex items-center gap-2">
                            <span role="img" aria-label="calendar" className="text-[13px] align-middle">
                                📆
                            </span>
                            <span className="text-xs">Pick a date</span>
                        </span>
                    </li>
                </ul>

                {showDatePicker && (
                    <div className="absolute left-1/2 top-0 -translate-x-1/2 mt-2 z-50 bg-white  border border-gray-200 " style={{ width: "100%" }}>
                        <DatePicker
                            className="my-zero-width-datepicker"
                            style={{ minWidth: 0 }}
                            popperProps={{
                                style: { minWidth: 0 }
                            }}
                            selected={customDate}
                            onChange={(date) => setCustomDate(date)}
                            showTimeSelect
                            timeFormat="hh:mm aa"
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            placeholderText="Select date and time"

                            inline
                            minDate={new Date()}
                           
                        />
                        <div className="flex  items-center mt-2 px-2" style={{ gap: '10px' }}>
                            <button
                                className="text-blue-600 text-xs font-medium hover:underline px-2 py-1 rounded"
                                onClick={() => setCustomDate(new Date())}
                                type="button"
                            >
                                ▼ Today
                            </button>
                            <button
                                className="text-red-500 text-xs font-medium hover:underline px-2 py-1 rounded"
                                onClick={() => setCustomDate(null)}
                                type="button"
                            >
                                ✗ Clear
                            </button>
                            <button
                                className="text-green-600 text-xs font-medium hover:underline px-2 py-1 rounded border border-green-600"
                                onClick={() => {
                                    if (customDate) {
                                        handleDateChange(customDate);
                                    }
                                }}
                                type="button"
                            >
                                ✔ Save
                            </button>
                        </div>
                    </div>
                )}

                {/* Checkboxes */}
                <div className="px-2 pt-2 pb-3">
    <label className="flex items-center gap-2 text-xs text-gray-800 mb-1">
        <input
            type="checkbox"
            className="form-checkbox rounded border-gray-300"
            checked={myDayChecked}
            onChange={(e) => setMyDayChecked(e.target.checked)}
        />
        Add this item to My Day plan
    </label>
    <label className="flex items-center gap-2 text-xs text-gray-800">
        <input
            type="checkbox"
            className="form-checkbox rounded border-gray-300"
            checked={deadlineChecked}
            onChange={(e) => setDeadlineChecked(e.target.checked)}
        />
        Also update the deadline date
    </label>
</div>
            </div>
        </div>
    );
};

export default ReminderMe;
